import React from 'react';
import { AREAS } from '../data/site';

// Google Maps embed showing our service area centred on Leamington Spa.
// The `q=` parameter lists every village so the map covers the whole area we serve.
// We use the free embed endpoint (no API key required).
export const ServiceAreaMap = ({ className = '' }) => {
  const focus = 'Leamington Spa, Warwickshire, UK';
  const src = `https://maps.google.com/maps?q=${encodeURIComponent(focus)}&t=&z=11&ie=UTF8&iwloc=&output=embed`;

  return (
    <div className={`relative bg-[#0A0A0A] border border-[#E8B842]/20 ${className}`}>
      <div className="aspect-[16/9] w-full">
        <iframe
          title="Leamington Gutters — service area map covering Leamington Spa, Warwick and surrounding villages"
          src={src}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="w-full h-full grayscale-[0.4] contrast-[1.05]"
          style={{ border: 0 }}
          allowFullScreen
          data-testid="service-area-map"
        />
      </div>
      {/* Pin legend overlay */}
      <div className="absolute top-3 left-3 bg-[#050505]/90 backdrop-blur-sm border border-[#E8B842]/30 px-3 py-2 pointer-events-none max-w-[220px]">
        <div className="font-display uppercase tracking-widest text-[10px] text-[#E8B842]">
          Based in
        </div>
        <div className="font-display uppercase font-bold text-white text-sm">
          Leamington Spa
        </div>
        <div className="text-[10px] text-[#A3A3A3] leading-snug mt-1">
          Covering {AREAS.length}+ towns and villages across Warwickshire
        </div>
      </div>
    </div>
  );
};

export default ServiceAreaMap;
